var checkUserAgentProperty = function () {
    return window && window.navigator && window.navigator.userAgent;
};
export var isTouchDevice = function () {
    return !!(typeof window !== 'undefined' &&
        ('ontouchstart' in window || navigator.msMaxTouchPoints));
};
var DeviceDetector = /** @class */ (function () {
    function DeviceDetector() {
    }
    /**
     * Methods logic extracted from the ClientJS library
     * https://github.com/jackspirou/clientjs/blob/d7584e10a4e45a4a96d712cd4292465aeedc0218/src/client.js#L338
     */
    // Is Mobile.  Check if the browser is on an android mobile device
    DeviceDetector.prototype.isMobileAndroid = function () {
        return checkUserAgentProperty()
            ? !!window.navigator.userAgent.match(/Android/i)
            : null;
    };
    // Is Mobile iOS.  Check if the browser is on an Apple iOS device
    DeviceDetector.prototype.isMobileIOS = function () {
        return checkUserAgentProperty()
            ? !!window.navigator.userAgent.match(/iPhone|iPad|iPod/i)
            : null;
    };
    return DeviceDetector;
}());
export { DeviceDetector };
export default new DeviceDetector();
